import { render, staticRenderFns } from "./ExportPortSelect.vue?vue&type=template&id=20466f90&"
import script from "./ExportPortSelect.vue?vue&type=script&lang=js&"
export * from "./ExportPortSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports